import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { BiData, BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ThumbMiddleContent from '@wix/da-ds/pkg/thumbs/legos/ThumbMiddleContent';
import PointsIcon from '@wix/da-ds/pkg/Icons/Points';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import ThumbStatusIndicator from '@wix/da-ds/pkg/thumbs/ThumbStatusIndicator';
import HoverOnly from '@wix/da-ds/pkg/thumbs/OverlayHelpers/HoverOnly';
import { useRestrictToLoggedIn } from '../../../../../../utils/hooks/useRestrictToLoggedIn';
import { LoggedOutReturnType } from '../../../../../../redux/loggedout';
import { normalizePremiumFolderData } from '../../../../../../utils/normalizePremiumFolderData';
import { DeviationTypes } from '../../../../../../types/deviation';
import { getDeviationResourceType, getDeviationType } from '../../../../../_helpers';
const unlockHint = (type, isMobile)=>{
    if (type === DeviationTypes.FILM) {
        return isMobile ? 'deviationview.overlay.premiumFolder.unlockHint.pay.mobile.video' : 'deviationview.overlay.premiumFolder.unlockHint.pay.video';
    }
    return isMobile ? 'deviationview.overlay.premiumFolder.unlockHint.pay.mobile' : 'deviationview.overlay.premiumFolder.unlockHint.pay';
};
const PremiumLockedMiddleContent = ({ deviation , thumbWidth , thumbHeight , className  })=>{
    var _deviation_author;
    const { t  } = useTranslation();
    const isMobile = useContext(MobileContext);
    const { restrictToLoggedIn  } = useRestrictToLoggedIn();
    const { pointPrice , folderId , subproductId , formattedDollarPrice  } = normalizePremiumFolderData(deviation.premiumFolderData);
    const showSmallButton = thumbWidth && thumbWidth < 250;
    const canShowDescription = thumbWidth && thumbHeight && thumbWidth > 230 && (thumbWidth > 400 ? thumbHeight > 230 : thumbHeight > 260);
    const canShowButton = thumbHeight && thumbHeight > 200;
    const isUnreasonablySmall = thumbHeight && thumbHeight < 160 || thumbWidth && thumbWidth < 120;
    const buttonTitle = useMemo(()=>{
        if (!canShowButton) {
            return;
        }
        if (showSmallButton) {
            return t('deviationview.overlay.premiumFolder.button.pay.short');
        }
        if (isMobile || pointPrice === undefined || pointPrice < 80) {
            return t('deviationview.overlay.premiumFolder.button.pay.mobile', {
                dollarPrice: formattedDollarPrice
            });
        }
        return t('deviationview.overlay.premiumFolder.button.pay', {
            postProcess: 'reactPostprocessor',
            dollarPrice: formattedDollarPrice,
            pointPrice,
            pointsIcon: /*#__PURE__*/ React.createElement(PointsIcon, {
                size: IconSize.TINY,
                disableDefaultColors: true
            })
        });
    }, [
        canShowButton,
        formattedDollarPrice,
        isMobile,
        pointPrice,
        showSmallButton,
        t
    ]);
    if (isUnreasonablySmall) {
        return /*#__PURE__*/ React.createElement(HoverOnly, {
            reverseHidden: true
        }, /*#__PURE__*/ React.createElement(ThumbMiddleContent, {
            icon: /*#__PURE__*/ React.createElement(ThumbStatusIndicator, {
                type: "premium-folder",
                size: "large"
            }),
            className: className
        }));
    }
    const checkoutLink = subproductId ? Url.checkoutLink(subproductId) : undefined;
    return /*#__PURE__*/ React.createElement(ThumbMiddleContent, {
        icon: /*#__PURE__*/ React.createElement(ThumbStatusIndicator, {
            type: "premium-folder",
            size: "large"
        }),
        subtitle: canShowDescription ? t(unlockHint(getDeviationType(deviation), isMobile)) : undefined,
        buttonTitle: buttonTitle,
        biData: BiData({
            evid: 361,
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId,
            authorid: (_deviation_author = deviation.author) === null || _deviation_author === void 0 ? void 0 : _deviation_author.useridUuid,
            galleryid: folderId !== null && folderId !== void 0 ? folderId : 0,
            points: pointPrice,
            rank: BiContextProvidedValue,
            reason_shown: BiContextProvidedValue,
            section_typeid: BiContextProvidedValue,
            sectionid: BiContextProvidedValue,
            sectionname: BiContextProvidedValue,
            sectionrank: BiContextProvidedValue,
            sectiontype: BiContextProvidedValue,
            sort_type: BiContextProvidedValue,
            widgetname: BiContextProvidedValue
        }),
        onButtonClick: restrictToLoggedIn(ReferralType.ACTION_BAR, ()=>{
            if (checkoutLink) window.location.href = checkoutLink;
        }, checkoutLink, LoggedOutReturnType.JOIN_ONLY),
        className: className
    });
};
PremiumLockedMiddleContent.displayName = 'PremiumLockedMiddleContent';
export default PremiumLockedMiddleContent;
